import type { PropsWithChildren } from "react"
import React from "react"

import type { Listing } from "~graphql/generated/graphql"
import Map from "~components/shared/map/map"
import { TEST_IDS } from "~config/test-ids"

import TripMarker from "./trip-marker"

interface Props extends PropsWithChildren {
    readonly location: Listing["location"]
    readonly type?: Listing["type"]
}

export default function TripMap({ location, type }: Props) {
    if (!location) return null

    const mapOptions = {
        zoomControl: false,
        scaleControl: false,
        draggable: true,
        fullscreenControl: false,
    }
    const marker = {
        lat: Number.isNaN(location.lat) ? 0 : location.lat || 0,
        lng: Number.isNaN(location.lng) ? 0 : location.lng || 0,
    }

    return (
        <Map options={() => mapOptions} markers={[marker]}>
            <TripMarker
                lat={Number.isNaN(location.lat) ? 0 : location.lat || 0}
                lng={Number.isNaN(location.lng) ? 0 : location.lng || 0}
                type={type}
                testId={TEST_IDS.LOCATION_MARKER}
            />
        </Map>
    )
}
